// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const SettlementCurrenciesTable: MarkdocTagRegistration = {
  tag: 'settlement-currencies-table',
  component: 'SettlementCurrenciesTable',
  attributes: {
    currencies: {type: Array},
  },
};

export const NonLocalPayoutSettlementCurrenciesTable: MarkdocTagRegistration = {
  tag: 'non-local-settlement-currencies-table',
  component: 'NonLocalPayoutSettlementCurrencies',
};

export const ConnectPayoutSettlementCurrenciesTable: MarkdocTagRegistration = {
  tag: 'connect-settlement-currencies-table',
  component: 'ConnectCurrencies',
};
